import "./Header.css";

function Header() {
  return (
    <div className="Home__header Header">
      <div className="Header__logo Logo">
        <span className="Logo__titulo"> X-MEN </span>
      </div>
    </div>
  );
}

export { Header };
